
import Vue from 'vue'
export default Vue.extend({
  scrollToTop: true,
  head() {
    return {
      title: '보유기술',
    }
  },
})
